import React, { useEffect, useState } from "react";
import { useI18n } from "../i18n";
import { LLC, isLLCFormed } from "../legal";
import api from "../api";

export default function Footer() {
  const { t, lang } = useI18n();
  const [topCaps, setTopCaps] = useState([]);
  useEffect(() => {
    api
      .get("/public/capabilities")
      .then(({ data }) => setTopCaps((data || []).slice(0, 10)))
      .catch(() => {});
  }, []);
  return (
    <footer
      style={{ borderTop: "1px solid var(--line)", background: "var(--ink)", color: "white" }}
      data-testid="site-footer"
    >
      {/* Brief SEO V2 · #14 — Internal linking: top 10 capabilities (each /c/{slug}) */}
      {topCaps.length > 0 && (
        <div
          className="container-cd py-10"
          style={{ borderBottom: "1px solid rgba(255,255,255,0.08)" }}
          data-testid="footer-top-capabilities"
        >
          <div className="overline" style={{ color: "rgba(255,255,255,0.5)" }}>
            {lang === "es" ? "CAPACIDADES PRINCIPALES" : "TOP CAPABILITIES"}
          </div>
          <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2 text-sm">
            {topCaps.map((c) => (
              <a
                key={c.slug}
                href={`/c/${c.slug}`}
                className="hover:text-[color:var(--orange)]"
                style={{ color: "rgba(255,255,255,0.78)" }}
                data-testid={`footer-cap-${c.slug}`}
              >
                {c.name}
                <span
                  className="ml-1.5 font-mono text-xs"
                  style={{ color: "rgba(255,255,255,0.4)" }}
                >
                  · {c.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      )}
      <div className="container-cd py-16 grid md:grid-cols-4 gap-8">
        <div>
          <div className="font-display text-2xl">CORRIDOR DIGITAL</div>
          <div className="overline mt-2" style={{ color: "rgba(255,255,255,0.6)" }}>
            CHIHUAHUA ↔ EL PASO · IMMEX DIRECTORY OF RECORD
          </div>
          <p className="mt-4 text-sm" style={{ color: "rgba(255,255,255,0.7)", maxWidth: 360 }}>
            {t("landing.footer.line")}
          </p>
        </div>
        <div>
          <div className="overline" style={{ color: "rgba(255,255,255,0.5)" }}>FOR MANUFACTURERS</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href="/register" className="hover:text-[color:var(--orange)]">{t("nav.signup")}</a></li>
            <li><a href="/pricing" className="hover:text-[color:var(--orange)]">{t("nav.pricing")}</a></li>
            <li><a href="/founding" className="hover:text-[color:var(--orange)]">{lang === "es" ? "Founding 10" : "Founding 10"}</a></li>
            <li><a href="/guides/claim-your-plant" className="hover:text-[color:var(--orange)]" data-testid="footer-claim-guide-link">{lang === "es" ? "Reclama tu planta" : "Claim your plant"}</a></li>
          </ul>
        </div>
        <div>
          <div className="overline" style={{ color: "rgba(255,255,255,0.5)" }}>FOR US BUYERS</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href="/directory" className="hover:text-[color:var(--orange)]">{t("nav.directory")}</a></li>
            <li><a href="/digest" className="hover:text-[color:var(--orange)]">{t("nav.digest")}</a></li>
            <li><a href="/roi" className="hover:text-[color:var(--orange)]" data-testid="footer-roi-link">{lang === "es" ? "Calculadora ROI" : "ROI calculator"}</a></li>
            <li><a href="/guides/verify-evidence" className="hover:text-[color:var(--orange)]" data-testid="footer-verify-guide-link">{lang === "es" ? "Cómo verificar evidencia" : "How to verify evidence"}</a></li>
            <li><a href="/guides/request-evidence" className="hover:text-[color:var(--orange)]" data-testid="footer-request-guide-link">{lang === "es" ? "Solicitar evidencia" : "Request evidence"}</a></li>
          </ul>
        </div>
        <div>
          <div className="overline" style={{ color: "rgba(255,255,255,0.5)" }}>COMPANY</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href="/about" className="hover:text-[color:var(--orange)]" data-testid="footer-about-link">{lang === "es" ? "Acerca" : "About"}</a></li>
            <li><a href="/guides" className="hover:text-[color:var(--orange)]" data-testid="footer-guides-link">{lang === "es" ? "Guías" : "Guides"}</a></li>
            <li><a href="/legal/terms" className="hover:text-[color:var(--orange)]" data-testid="footer-terms-link">{lang === "es" ? "Términos" : "Terms"}</a></li>
            <li><a href="/legal/privacy" className="hover:text-[color:var(--orange)]" data-testid="footer-privacy-link">{lang === "es" ? "Privacidad" : "Privacy"}</a></li>
            <li><a href="/legal/refund" className="hover:text-[color:var(--orange)]" data-testid="footer-refund-link">{lang === "es" ? "Reembolsos" : "Refunds"}</a></li>
          </ul>
        </div>
      </div>
      <div
        className="container-cd py-6 flex flex-col md:flex-row md:items-center justify-between gap-3 font-mono text-xs"
        style={{ borderTop: "1px solid rgba(255,255,255,0.15)", color: "rgba(255,255,255,0.5)" }}
      >
        <span data-testid="footer-llc-attribution">
          © {new Date().getFullYear()} ·{" "}
          {lang === "es" ? "Operado por" : "Operated by"}{" "}
          <strong style={{ color: "rgba(255,255,255,0.85)" }}>
            {isLLCFormed ? LLC.name : LLC.short_name}
          </strong>
          {isLLCFormed ? null : (
            <span style={{ color: "rgba(255,255,255,0.4)" }}>
              {" "}·{" "}
              {lang === "es" ? "constitución en proceso" : "entity formation pending"}
            </span>
          )}
        </span>
        <span className="flex items-center gap-4">
          <a
            href="/api/sitemap.xml"
            className="hover:text-[color:var(--orange)]"
            data-testid="footer-sitemap-link"
          >
            sitemap
          </a>
          <span>v0.1 · CIUDAD JUÁREZ · CHIH. · MX</span>
        </span>
      </div>
    </footer>
  );
}
